
export default [
  {
    url: '/cases',
    slug: 'cases',
    name: 'Cases',
    icon: 'FileTextIcon',
    i18n: 'menus.verticalMenu.cases',
    rule: 'public' //TODO mudar para cada acl
  },
  // {
  //   url: "/",
  //   name: "Home",
  //   slug: "home",
  //   icon: "HomeIcon",
  //   i18n: 'menus.verticalMenu.home',
  //   rule: 'public'
  // },
  {
    url: '/users',
    slug: 'users',
    name: 'Users',
    icon: 'UsersIcon',
    i18n: 'menus.verticalMenu.users',
    rule: 'admin'
  },
  {
    url: '/coupoms',
    slug: 'coupoms',
    name: 'Coupoms',
    icon: 'PercentIcon',
    i18n: 'menus.verticalMenu.coupoms',
    rule: 'admin'
  },
  {
    url: '/products',
    slug: 'products',
    name: 'Products',
    icon: 'BoxIcon',
    i18n: 'menus.verticalMenu.products',
    rule: 'admin'
  },
  {
    url: "/shop",
    name: "shop",
    slug: "shop",
    icon: "ShoppingBagIcon",
    i18n: 'menus.verticalMenu.shop',
    rule: 'public'
  },
  {
    url: "/students",
    name: "students",
    slug: "students",
    icon: "UserPlusIcon",
    i18n: 'menus.verticalMenu.students',
    rule: 'instructor'
  },
  {
    url: '/settings',
    slug: 'settings',
    name: 'Settings',
    icon: 'SettingsIcon',
    i18n: 'menus.verticalMenu.settings',
    rule: 'admin'
  },
  {
    url: '/notifications',
    slug: 'notifications',
    name: 'notifications',
    icon: 'BellIcon',
    i18n: 'menus.verticalMenu.notifications',
    rule: 'public'
  },
  {
    url: '/archive',
    slug: 'archive',
    name: 'archive',
    icon: 'ListIcon',
    i18n: 'menus.verticalMenu.archive',
    rule: 'public'
  },
  // {
  //   url: '/report',
  //   slug: 'page-profile-settings',
  //   name: 'UserSettings',
  //   icon: 'SettingsIcon',
  //   i18n: 'menus.verticalMenu.userSettings',
  //   rule: 'admin'
  // },
]
